import { ColorsConfig } from '@ddt-web/config';
import { CellData, CellUtil, ColumnConfig, ComponentData, TabData, TableData } from '@ddt-web/data-service';
import { HoldingsTableUtil } from '@ddt-web/holdings';
import * as get from 'lodash/get';


export class AggregatedPortfolioComposition {
	public getTransformedTab(
		data: ComponentData,
		categoryId: string = 'weight',
		formatter?: Function,
		assetClassColors: { [key: string]: string } = ColorsConfig.ASSET_CLASS_COLORS
	): TabData[] {
		const tabData = data.tabs[0];
		const tableData = tabData.tableData;

		const tabDataArray: TabData[] = [];

		tableData.forEach(tableData => {
			const categoryIndexMap = HoldingsTableUtil.populateCategoryIndexMap(tableData);
			const categoryWeightMap = HoldingsTableUtil.populateCategoryWeightMap(tableData, categoryIndexMap);
			const categoriesArray = Array.from(categoryIndexMap.keys());

			this.buildTransformedTab(tableData, tabData, categoriesArray, categoryWeightMap, categoryIndexMap, tabDataArray, categoryId, formatter, assetClassColors);
		});

		return tabDataArray;
	}

	private buildTransformedTab(
		tableData: TableData,
		tabData: TabData,
		categoriesArray: any[],
		categoryWeightMap: Map<any, any>,
		categoryIndexMap: Map<any, any>,
		transformedTabArray: TabData[],
		categoryId: string,
		formatter?: Function,
		assetClassColors: { [key: string]: string } = ColorsConfig.ASSET_CLASS_COLORS
	): TabData {
		const transformedTab = new TabData(
			tabData.config,
			[
				new TableData(
					tabData.tableData[0].headersX.filter(header => get(header, 'config.id') === 'name'),
					[],
					[],
					tabData.tableData[0].portfolioData,
					new CellData(null, null)
				)
			],
			tabData.displayConfig,
			tabData.error
		);
		categoriesArray.forEach(category => {
			// TODO yahu: Make id for these cells to be static string for now, otherwise it will be increasing numbers and break test (numbers mismatch)
			const headerY = new CellData(new ColumnConfig(null, null, null, 'cell'), category, category, null, { backgroundColor: assetClassColors[category] }, []);
			const cellrow = [];

			categoryWeightMap.get(category).forEach((weight, colIndex) => {
				const cell = new CellData(
					new ColumnConfig(null, null, null, 'cell'),
					weight,
					HoldingsTableUtil.formatWeight(weight, formatter),
					null,
					{ backgroundColor: assetClassColors[category] },
					[]
				);
				categoryIndexMap.get(category).forEach(rowIndex => {
					const childWeight = tableData.cells[rowIndex].filter(cell => get(cell, 'config.id') === categoryId);
					cell.children.push(new CellData(new ColumnConfig(null, null, null, 'cell'), childWeight[colIndex].rawValue, childWeight[colIndex].formattedValue));
				});
				cellrow.push(cell);
			});

			categoryIndexMap.get(category).forEach(rowIndex => {
				const value = CellUtil.getById(tableData.cells[rowIndex], 'description').formattedValue;
				const updatedValue = HoldingsTableUtil.shouldDisplaySecurityParametricIndicators(tableData.cells[rowIndex]) ? value + '*' : value;
				headerY.children.push(new CellData(new ColumnConfig(null, null, null, 'cell'), value, updatedValue, null, { ticker: tableData.headersY[rowIndex].formattedValue }));
			});

			transformedTab.tableData[0].headersY.push(headerY);
			transformedTab.tableData[0].cells.push(cellrow);
		});

		transformedTabArray.push(transformedTab);
		return transformedTab;
	}
}
